import {Link} from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';

import LinkBox from "../LinkBox"

import "./LegoPlanets.css";
import "../Common.css"

function LegoPlanets()
{
    return (
        <div>
            <Container>
                <Row>
                    <Col xs={{ span: 12 }} className="topBuffer spacer-sm">
                        <img src="assets/LegoPlanets/Previews/LegoPlanets.png" className="center-block" alt="LegoPlanets"/>
                    </Col>
                    <LinkBox name="Small Planets" href="SmallPlanets" image="assets/LegoPlanets/Previews/SunScale.png" offset={1} />
                    <LinkBox name="Large Planets" href="LargePlanets" image="assets/LegoPlanets/Previews/JupiterScale.png" offset={0} />
                    <LinkBox name="Earth" href="LegoEarth" image="assets/LegoPlanets/Previews/LegoGlobe.png" offset={1} />
                </Row>
            </Container>
            <Link to="/Home" className="logo"></Link>
        </div>
      )
}

export default LegoPlanets;